var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-card',{attrs:{"elevation":hover ? 6 : 2}},[_c('v-card-text',[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"350px"}})])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }